<template>
  <div id="app">
    <!-- Nav bar -->
    <b-navbar id="navb" sticky toggleable="lg" type="dark" variant="dark">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item to="/pc-chooser">PC Chooser</b-nav-item>
          <b-nav-item href="https://medium.com/robot-thoughts">Blog</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav
          id="adminDropDown"
          class="ml-auto"
          style="visibility: hidden"
        >
          <b-nav-item-dropdown text="Admin" right>
            <b-dropdown-item to="analytics">Analytics</b-dropdown-item>
            <b-dropdown-item to="pc_chooser_admin"
              >PC Chooser Admin</b-dropdown-item
            >
            <b-dropdown-item @click="logout">Log out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- Component -->
    <router-view />
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "App",
  metaInfo: {
    title: "Choose.Computer",
    titleTemplate: "%s | Choose Computer",
    htmlAttrs: {
      lang: "en",
    },
  },
  methods: {
    logout: function () {
      if (confirm("Do you wish to sign out?")) {
        firebase
          .auth()
          .signOut()
          .then(function () {})
          .catch(function (error) {
            alert(error.message);
          });
      }
    },
  },
  mounted() {
    let isAdminDropDownActive = false;
    let navBarAdmin = document.getElementById("adminDropDown");

    var lang = navigator.language;

    let _this = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // user is signed in
        if (!isAdminDropDownActive) {
          navBarAdmin.style.visibility = "visible";
          isAdminDropDownActive = true;
        }
      } else {
        // no user is signed in
        if (isAdminDropDownActive) {
          navBarAdmin.style.visibility = "hidden";
          isAdminDropDownActive = false;
        }
      }
    });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#navb {
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue